<ng-template #formError>
  @if (form.dirty && form.invalid) {
    <span
      class="top-margin-15"
      color="alert-red"
    >
      @if (form.hasError("max")) {
        <!-- TODO: currency -->
        {{
          "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.ERRORS.TOTAL_EXCEEDS_MAX" | translate: { max: form.errors?.max?.max | number: "1.0" : "hu" }
        }}
      }
      @if (form.hasError("required")) {
        {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.ERRORS.AT_LEAST_ONE_REQUIRED" | translate }}
      }
      <!-- Form is invalid but only child controls have errors -->
      @if (form.errors === null) {
        @for (invoiceForm of form.controls; track invoiceForm) {
          @if (invoiceForm.get("file")?.hasError("required")) {
            <div>
              {{
                "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.ERRORS.FILE_REQUIRED" | translate: { invoiceNumber: invoiceForm.value.invoice_number }
              }}
            </div>
          }
        }
      }
    </span>
  }
</ng-template>

<div class="flex vcenter title">
  <h2>{{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.TITLE" | translate }}</h2>
  @if (invoicesLoading) {
    <mat-progress-spinner
      mode="indeterminate"
      diameter="24"
    ></mat-progress-spinner>
  }
</div>

@if (ksziNotReady) {
  <div class="kszi-warning flex vcenter top-margin-10">
    <mat-icon color="warn">error_outline</mat-icon>
    <div class="flex column">
      <span>{{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.ERRORS.KSZI_NOT_READY" | translate }}</span>
    </div>
  </div>
}

@if (showKsziLoadingBanner) {
  <div class="kszi-warning flex vcenter top-margin-10">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="30"
    ></mat-progress-spinner>
    <div class="flex column">
      <span>{{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.KSZI_WARNING.LOADING_IN_PROGRESS" | translate }}</span>
      @if (ksziEstimatedFinishTime) {
        <span>
          {{
            "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.KSZI_WARNING.EXPECTED_TIME_TO_FINISH"
              | translate
                : {
                    estimated_time: ksziEstimatedFinishTime | date: "yyyy.MM.dd. HH:mm",
                  }
          }}
        </span>
      }
      @if (!ksziEstimatedFinishTime) {
        <span>
          {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.KSZI_WARNING.EXPECTED_TIME_PENDING" | translate }}
        </span>
      }
    </div>
  </div>
}

@if (invoiceMissingReason && invoiceMissingReason !== "invoice-missing-not-exists") {
  <div class="kszi-warning flex vcenter top-margin-10">
    <mat-icon color="accent">info</mat-icon>
    <div class="flex column">
      <span>
        {{
          "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.ERRORS.INVOICE_MISSING_REASON." + invoiceMissingReason
            | translate: { invoiceNumber: invoiceMissingNumber }
        }}
      </span>
    </div>
  </div>
}

@if (!ksziSyncInProgress && invoiceMissingReason === "invoice-missing-not-exists") {
  <div class="kszi-warning flex vcenter top-margin-10">
    <mat-icon color="accent">info</mat-icon>
    <div class="flex column">
      <span>
        {{
          "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.ERRORS.EXPECTED_INVOICE_STILL_MISSING"
            | translate: { invoiceNumber: invoiceMissingNumber ?? "" }
        }}
      </span>
    </div>
  </div>
}

@if (hasMultipleValidInvoices) {
  <div class="description top-margin-10">
    {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.DESCRIPTION" | translate }}
  </div>
}

<div class="flex column invoice-filters top-margin-10">
  <payee-form-field>
    <span payee-label>{{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.FILTER_LABEL" | translate }}</span>
    <input
      payee-input
      [formControl]="invoiceFilter"
    />
  </payee-form-field>
</div>

<section class="forms flex column">
  @if (validInvoicesDataSource.data.length > 0) {
    <div class="invoice-section flex column">
      <h3 class="invoice-section-title">
        {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.SECTION_VALID_INVOICES" | translate }}
      </h3>
      <table
        #validSort="matSort"
        mat-table
        matSort
        multiTemplateDataRows
        class="top-margin-15 mat-elevation-z1"
        [dataSource]="validInvoicesDataSource"
      >
        <ng-container matColumnDef="selected">
          <th
            *matHeaderCellDef
            mat-header-cell
          ></th>
          <td
            *matCellDef="let element"
            mat-cell
            class="alt-theme"
          >
            <div class="flex vcenter hcenter">
              @if (getInvoiceSelector(element)?.enabled) {
                <mat-checkbox
                  id="invoice-checkbox-{{ element.invoice_id }}"
                  color="accent"
                  [disabled]="invoicesLoading"
                  [checked]="getInvoiceSelector(element)?.value.selected"
                  (click)="$event.stopPropagation()"
                  (change)="toggleInvoice(element)"
                ></mat-checkbox>
              }
              @if (element.error_code) {
                <mat-icon
                  color="warn"
                  matTooltipClass="custom-tooltip"
                  matTooltipPosition="above"
                  [matTooltip]="'CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.ERROR_CODES.' + element.error_code | translate"
                >
                  warning_amber
                </mat-icon>
              }
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="invoice_number">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
          >
            {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.INVOICE_NUMBER" | translate }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            {{ element.invoice_number }}
          </td>
        </ng-container>
        <ng-container matColumnDef="due_date_at">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
          >
            {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.DUE_DATE" | translate }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            {{ element.due_date_at | date: "yyyy.MM.dd." }}
          </td>
        </ng-container>
        <ng-container matColumnDef="remaining_amount">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
          >
            {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.AMOUNT" | translate }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            {{ element.total_remaining_amount | number: "1.0" : "hu" }}
            {{ element.currency_iso }}
          </td>
        </ng-container>
        <ng-container matColumnDef="file">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
          >
            {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.FILE" | translate }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            @if (!element.file && getInvoiceSelector(element)?.value.index !== null) {
              <input
                #upload
                hidden
                type="file"
                accept="
                application/msword,
                application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                application/vnd.ms-powerpoint,
                application/vnd.openxmlformats-officedocument.presentationml.presentation,
                text/plain,
                application/vnd.ms-xpsdocument,
                image/jpg,
                image/jpeg,
                image/png,
                image/gif,
                image/bmp,
                image/tiff,
                image/svg+xml,
                image/vnd.adobe.photoshop,
                application/pdf,
                application/zip,
                application/x-rar-compressed,
                application/octet-stream,
                application/gzip,
                application/x-tar,
                application/vnd.ms-excel,
                application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
              "
                (click)="$event.stopPropagation()"
                (change)="uploadInvoice($event, element)"
              />
              <a
                class="invalid-file"
                href="#"
                role="button"
                (click)="$event.preventDefault(); $event.stopPropagation(); upload.click()"
                (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); upload.click()"
              >
                {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.UPLOAD_FILE" | translate }}
              </a>
            }
            @if (element.file) {
              @if (element.file.storage_url) {
                <a
                  target="_blank"
                  class="valid-file"
                  [href]="element.file.storage_url"
                  (click)="$event.stopPropagation()"
                >
                  {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.FILE_OK" | translate }}
                </a>
              }
              @if (!element.file.storage_url) {
                <div class="flex vcenter valid-file">
                  <span>{{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.FILE_OK" | translate }}</span>
                </div>
              }
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="corrections">
          <td
            *matCellDef="let element"
            mat-cell
            colspan="6"
          >
            <div class="correction-title">
              {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.CORRECTIONS.INVOICE_TITLE" | translate }}
            </div>
            <table class="correction-table">
              <td class="index">1.</td>
              <td class="invoice-number">{{ element.invoice_number }}</td>
              <td class="amount">
                {{ element.remaining_amount | number: "1.0" : "hu" }}
                {{ element.currency_iso }}
              </td>
            </table>
            <div class="correction-title">
              {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.CORRECTIONS.CORRECTIONS_TITLE" | translate }}
            </div>
            <table class="correction-table">
              @for (correction of element.corrections; track correction.invoice_number; let i = $index) {
                <tr>
                  <td class="index">{{ i + 2 }}.</td>
                  <td class="invoice-number">{{ correction.invoice_number }}</td>
                  <td class="amount">
                    {{ correction.remaining_amount | number: "1.0" : "hu" }}
                    {{ correction.currency_iso }}
                  </td>
                </tr>
              }
            </table>
          </td>
        </ng-container>
        <tr
          *matHeaderRowDef="displayedColumns"
          mat-header-row
        ></tr>
        <tr
          *matRowDef="let row; columns: displayedColumns"
          mat-row
          class="select-row"
          [class.select-row--clickable]="isInvoiceRowClickable(row)"
          (click)="onInvoiceRowClick(row, $event)"
        ></tr>
        <tr
          *matRowDef="let row; columns: ['corrections']"
          mat-row
          class="corrections-row"
          [class.has-corrections]="invoiceHasCorrections(row)"
        ></tr>
      </table>
      @if (validInvoicesDataSource.data.length > invoicePageSize) {
        <mat-paginator
          #validPaginator
          showFirstLastButtons
          class="invoice-table-paginator top-margin-10 mat-elevation-z1"
          [pageSizeOptions]="invoicePageSizeOptions"
          [pageSize]="invoicePageSize"
        ></mat-paginator>
      }
    </div>
  }

  @if (showInvalidInvoicesSection) {
    <div class="invoice-section flex column">
      <h3 class="invoice-section-title top-margin-20">
        {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.SECTION_INVALID_INVOICES" | translate }}
      </h3>
      <table
        #invalidSort="matSort"
        mat-table
        matSort
        multiTemplateDataRows
        class="top-margin-15 mat-elevation-z1"
        [dataSource]="invalidInvoicesDataSource"
      >
        <ng-container matColumnDef="selected">
          <th
            *matHeaderCellDef
            mat-header-cell
          ></th>
          <td
            *matCellDef="let element"
            mat-cell
            class="alt-theme"
          >
            <div class="flex vcenter hcenter">
              @if (getInvoiceSelector(element)?.enabled) {
                <mat-checkbox
                  id="invoice-checkbox-invalid-{{ element.invoice_id }}"
                  color="accent"
                  [disabled]="invoicesLoading"
                  [checked]="getInvoiceSelector(element)?.value.selected"
                  (click)="$event.stopPropagation()"
                  (change)="toggleInvoice(element)"
                ></mat-checkbox>
              }
              @if (element.error_code) {
                <mat-icon
                  color="warn"
                  matTooltipClass="custom-tooltip"
                  matTooltipPosition="above"
                  [matTooltip]="'CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.ERROR_CODES.' + element.error_code | translate"
                >
                  warning_amber
                </mat-icon>
              }
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="invoice_number">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
          >
            {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.INVOICE_NUMBER" | translate }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            {{ element.invoice_number }}
          </td>
        </ng-container>
        <ng-container matColumnDef="due_date_at">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
          >
            {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.DUE_DATE" | translate }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            {{ element.due_date_at | date: "yyyy.MM.dd." }}
          </td>
        </ng-container>
        <ng-container matColumnDef="remaining_amount">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
          >
            {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.AMOUNT" | translate }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            {{ element.total_remaining_amount | number: "1.0" : "hu" }}
            {{ element.currency_iso }}
          </td>
        </ng-container>
        <ng-container matColumnDef="file">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
          >
            {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.FILE" | translate }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            @if (!element.file && getInvoiceSelector(element)?.value.index !== null) {
              <input
                #uploadInvalid
                hidden
                type="file"
                accept="
                application/msword,
                application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                application/vnd.ms-powerpoint,
                application/vnd.openxmlformats-officedocument.presentationml.presentation,
                text/plain,
                application/vnd.ms-xpsdocument,
                image/jpg,
                image/jpeg,
                image/png,
                image/gif,
                image/bmp,
                image/tiff,
                image/svg+xml,
                image/vnd.adobe.photoshop,
                application/pdf,
                application/zip,
                application/x-rar-compressed,
                application/octet-stream,
                application/gzip,
                application/x-tar,
                application/vnd.ms-excel,
                application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
              "
                (click)="$event.stopPropagation()"
                (change)="uploadInvoice($event, element)"
              />
              <a
                class="invalid-file"
                href="#"
                role="button"
                (click)="$event.preventDefault(); $event.stopPropagation(); uploadInvalid.click()"
                (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); uploadInvalid.click()"
              >
                {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.UPLOAD_FILE" | translate }}
              </a>
            }
            @if (element.file) {
              @if (element.file.storage_url) {
                <a
                  target="_blank"
                  class="valid-file"
                  [href]="element.file.storage_url"
                  (click)="$event.stopPropagation()"
                >
                  {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.FILE_OK" | translate }}
                </a>
              }
              @if (!element.file.storage_url) {
                <div class="flex vcenter valid-file">
                  <span>{{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.FILE_OK" | translate }}</span>
                </div>
              }
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="corrections">
          <td
            *matCellDef="let element"
            mat-cell
            colspan="6"
          >
            <div class="correction-title">
              {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.CORRECTIONS.INVOICE_TITLE" | translate }}
            </div>
            <table class="correction-table">
              <td class="index">1.</td>
              <td class="invoice-number">{{ element.invoice_number }}</td>
              <td class="amount">
                {{ element.remaining_amount | number: "1.0" : "hu" }}
                {{ element.currency_iso }}
              </td>
            </table>
            <div class="correction-title">
              {{ "CASE_FORM.FORMS.SZAMLAZZHU_INVOICES.CORRECTIONS.CORRECTIONS_TITLE" | translate }}
            </div>
            <table class="correction-table">
              @for (correction of element.corrections; track correction.invoice_number; let i = $index) {
                <tr>
                  <td class="index">{{ i + 2 }}.</td>
                  <td class="invoice-number">{{ correction.invoice_number }}</td>
                  <td class="amount">
                    {{ correction.remaining_amount | number: "1.0" : "hu" }}
                    {{ correction.currency_iso }}
                  </td>
                </tr>
              }
            </table>
          </td>
        </ng-container>
        <tr
          *matHeaderRowDef="displayedColumns"
          mat-header-row
        ></tr>
        <tr
          *matRowDef="let row; columns: displayedColumns"
          mat-row
          class="select-row"
          [class.select-row--clickable]="isInvoiceRowClickable(row)"
          (click)="onInvoiceRowClick(row, $event)"
        ></tr>
        <tr
          *matRowDef="let row; columns: ['corrections']"
          mat-row
          class="corrections-row"
          [class.has-corrections]="invoiceHasCorrections(row)"
        ></tr>
      </table>
      @if (invalidInvoicesDataSource.data.length > invoicePageSize) {
        <mat-paginator
          #invalidPaginator
          showFirstLastButtons
          class="invoice-table-paginator top-margin-10 mat-elevation-z1"
          [pageSizeOptions]="invoicePageSizeOptions"
          [pageSize]="invoicePageSize"
          [pageSize]="invoicePageSize"
        ></mat-paginator>
      }
    </div>
  }

  <ng-template [ngTemplateOutlet]="formError"></ng-template>
</section>
